import * as process from 'process';
import { SiteList } from '../config';
import { ClientDomainType } from '../enums';
export var getAuthPortalUrl = function(clientPortalBase) {
    var _SiteList_flatMap_find;
    return ((_SiteList_flatMap_find = SiteList.flatMap(function(portal) {
        return portal.domains;
    }).find(function(domain) {
        return domain.hostname === clientPortalBase;
    })) === null || _SiteList_flatMap_find === void 0 ? void 0 : _SiteList_flatMap_find.authPortalUrl) || '';
};
export var getUrlDomainType = function(url) {
    if (url.includes('local') || url.includes('127.0.0.1')) return ClientDomainType.Local;
    if (url.includes('-qa-')) {
        return ClientDomainType.Qa;
    }
    if (url.includes('-dev-')) {
        return ClientDomainType.Develop;
    }
    if (url.includes('-uat-')) {
        return ClientDomainType.Uat;
    }
    return ClientDomainType.Production;
};
export var getMfeAuthPortalUrl = function(clientPortalBase) {
    var _SiteList_find, _domainList_find;
    var hostName = clientPortalBase || window.location.hostname;
    var _process_env_AUTH_API_URL;
    var domainType = getUrlDomainType((_process_env_AUTH_API_URL = process.env.AUTH_API_URL) !== null && _process_env_AUTH_API_URL !== void 0 ? _process_env_AUTH_API_URL : hostName);
    var _SiteList_find_domains;
    var domainList = (_SiteList_find_domains = (_SiteList_find = SiteList.find(function(portal) {
        return portal.domains.some(function(domain) {
            return domain.hostname === hostName || domain.authHostname === hostName;
        });
    })) === null || _SiteList_find === void 0 ? void 0 : _SiteList_find.domains) !== null && _SiteList_find_domains !== void 0 ? _SiteList_find_domains : [];
    var authUrl = domainList === null || domainList === void 0 ? void 0 : (_domainList_find = domainList.find(function(domain) {
        return domain.domainType === domainType;
    })) === null || _domainList_find === void 0 ? void 0 : _domainList_find.authPortalUrl;
    if (authUrl) {
        return authUrl;
    }
    return getAuthPortalUrl(hostName);
};
